import React, { useEffect, useState } from "react"
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const OrderListings: React.FunctionComponent<{ listingValue: any, onSaveOrder: any }> = (props) => {

    const [openPopUp, setOpenPopUp] = useState<boolean>(false);
    const [orderedImages, setOrderedImages] = useState<any[]>([]);
    const [isChangeOrder, setIsChangeOrder] = useState<boolean>(false);
    const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
    const { t } = useTranslation();

    useEffect(() => {
        if (props.listingValue) {
            setOrderedImages([...props.listingValue]);
        }
    }, [props.listingValue]);


    const handleDragStart = (index: number) => {
        setDraggedIndex(index);
    };

    const handleDragOver = (e: React.DragEvent, index: number) => {
        e.preventDefault();

        if (draggedIndex === null || draggedIndex === index) return;

        const newImages = [...orderedImages];
        const draggedItem = newImages[draggedIndex];

        newImages.splice(draggedIndex, 1);
        newImages.splice(index, 0, draggedItem);

        setOrderedImages(newImages);
        setDraggedIndex(index);
    };

    const handleDragEnd = () => {
        setDraggedIndex(null);
    };

    const handleCloseDialog = () => {
        setOpenPopUp(false);
    };

    const HandleSave = () => {
        setOpenPopUp(false)
        setIsChangeOrder(true)
        const newList = orderedImages.map((image: any, index: number) => ({
            ...image,
            order: index + 1,
        }));

        props.onSaveOrder(newList).then(() => {
            setIsChangeOrder(false)
        }).catch(() => {
            setIsChangeOrder(false)
        })

    }

    return (
        <>
            <button type="submit" className="button-reset reoder back-trans  border-trans padd-20" onClick={() => setOpenPopUp(true)}>
                {t("listingCreation.reorderImages")}
                {isChangeOrder && <div className="col-auto marg-left-5">
                    <div className="spinner-border text-primary" style={{ width: "20px", height: "20px" }} role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>}
            </button>

            <BootstrapDialog
                open={openPopUp}
                onClose={handleCloseDialog}
                aria-labelledby="customized-dialog-title"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle>
                    <div className="title-24">{t("listingCreation.orderListings")}</div>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <p className="para-16 mb-3">Drag and drop to reorder images</p>
                    
                    <div className="image-grid padd-10 border-D1D5DB border-16 shadow-drag">
                        {orderedImages.map((image: any, index: number) => (
                            <div
                                key={index}
                                className="image-container"
                                draggable={true}
                                onDragStart={() => handleDragStart(index)}
                                onDragOver={(e) => handleDragOver(e, index)}
                                onDragEnd={handleDragEnd}
                                style={{ cursor: 'grab' }}
                            >
                                <img src={image.src} alt={`Image ${index}`} />
                                {index === 0 && <div className="image-order-badge" style={{ background: '#4CAF50' }}>Cover</div>}
                            </div>
                        ))}
                    </div>

                    <div className="d-flex justify-content-end mt-4">
                        <button
                            onClick={HandleSave}
                            className="button-reset back-746AFF color-FFFFFF border-746AFF padd-15-30">
                            {t("propertiesPage.save")}
                        </button>
                    </div>
                </DialogContent>
            </BootstrapDialog>
        </>

    )
}
export default OrderListings;